//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
//  -- Components ---------------------
import { ArrowLeftOutlined } from '@ant-design/icons';
//  -- Constants ----------------------
//  -- Thunks -------------------------
import { Button, Col, message, Row } from 'antd';
import SpinLoader from 'components/Loader/SpinLoader';
import UserForm from 'features/forms/admin/User';
import { useEffect } from 'react';
import { connect } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleGetSchoolsListForCreateUser } from 'store/organizations/thunks';
import { getUserBooksById } from 'store/userBooks/thunks';
import SentryWrap from 'components/Sentry';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const StableWrapperMain = styled.div`
    margin-top:10px;
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------

const AddTeachers = ({}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentOrg = useCurrentOrg()
    const [data_loader, setDataLoader] = useState(false)
    const [schools, setSchools] = useState([])
    const [userBook,setUserBook] = useState({})
    const { userInfo, is_edit } = useMemo(() => {
        const { userData, isEdit } = location.state;
        return { userInfo: userData, is_edit: isEdit }
    }, [location.state])

    const getInfo = async () => {
        try {

            const response = await handleGetSchoolsListForCreateUser(currentOrg.id)
            if (response && response.success) {
                setSchools(response.data)
            } else {
                setSchools([])
                message.error(response?.message || "Something went wrong")
            }
        } catch (error) {
            console.log("error", error.message)
        }
    }
    const getUserBook = async () => {
        const userbook = await getUserBooksById(userInfo.id)
        if (userbook && userbook.id) {
            setUserBook(userbook)
        }
    }
    const getData = async () => {
        try {
            setDataLoader(true)
            if (currentOrg && currentOrg.id) {
                await getInfo()
            }
            if (userInfo && userInfo.id && userInfo.role == 'teacher') {
                await getUserBook()
            }
        } catch (error) {

        } finally {
            setDataLoader(false)
        }
    }
    useEffect(() => {
        getData()
    }, [currentOrg, userInfo])

   
    const backToDataBrowser = () => {
        if (location.state?.from === "global") {
            navigate('/global-admin-search');
            return;
        }
        navigate(`/data-browsers${userInfo.role?"?tab="+userInfo.role:''}`);
    };

    return (
        <SentryWrap>
        <SpinLoader dataloader={data_loader} />
            <Row>
                <Col lg={24}>
                    <Button type="link" primary style={{ paddingLeft: 0, fontSize: 17, marginBottom: 20 }} onClick={backToDataBrowser}>
                        <ArrowLeftOutlined />
                        Back
                    </Button>
                </Col>
            </Row>
            <StableWrapperMain>
                <UserForm
                    userData={userInfo || {}}
                    editing={is_edit}
                    onClose={() => {
                    }}
                    schools={schools}
                    currentOrg={currentOrg}
                    userBook={userBook}
                />
            </StableWrapperMain>
        </SentryWrap>
    );
};


const mapStateToProps = (state) => ({
    schools: state.schools,
    booksAllList: state.booksAllList,
    users: state.users
});

export default connect(mapStateToProps, null)(AddTeachers);
